import { useState, useRef } from 'react';

export default function useDropdownState() {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const popoverRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const transitionRef = useRef<boolean>(false);
  const lastCloseTimeRef = useRef<number>(0);

  const resetState = () => {
    setPage(0);
    setSearch('');
  };

  return {
    isOpen,
    setIsOpen,
    search,
    setSearch,
    page,
    setPage,
    popoverRef,
    triggerRef,
    searchInputRef,
    transitionRef,
    lastCloseTimeRef,
    resetState
  };
}
